var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38v14.25A2.4 2.4 0 0126.58 21z",
    fill: "#EBF1F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.02V4h5v.02a7.5 7.5 0 010 14.96V19h-5v-.02a7.5 7.5 0 010-14.96z",
    fill: "#0165AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.74a4.5 4.5 0 000-8.48v8.48zm-3-8.48a4.5 4.5 0 000 8.48V7.26zM12.5 18a6.5 6.5 0 110-13 6.5 6.5 0 010 13z",
    fill: "#FFF"
  })));
}

export default SvgPaymentIconDiners;